module.exports = __webpack_public_path__ + "img/logo-light_.ac4d15de.png";